"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchParams = exports.testCaseSearchResult = void 0;
var testCaseSearchResult = [
    {
        case_id: 19192,
        case_status: "Automated",
        process_instance_guid: "21687",
        process_instance_id: 21687,
        case_uid: "123",
        case_encounter_id: 13968,
        facility: "HFM",
        process_status: "Done",
        run_type: "prediction",
        primary_process_indicator: true,
        source_type: "HL7",
        service_line: "Radiology",
        tenant_code: "MGH",
        tenant_name: "Massachusetts General Hospital",
        tenant_timezone: "America/New_York",
        health_system_code: "PHS",
        patient_id: 209193,
        patient_name: "SCENARIO04-1, CARMEN",
        date_of_birth: "1961-09-11",
        patient_gender: "F",
        patient_identifier: { number: "224725", issuer: "EPIC", type: "PMRN" },
        visit_number: {
            number: "3304249259",
            issuer: "EPIC",
            type: "VISIT_NUMBER"
        },
        account_number: { number: "6122200455", issuer: null, type: null },
        patient_class: "EMERGENCY",
        patient_type: null,
        reason_for_visit: "*TIA, initial exam. R sided pronator drift, recent R pons stroke off coumading for 2 days. ? CVA vs complex migraine",
        primary_insurance: null,
        primary_insurance_category: null,
        encounter_identifier: {
            number: "3304249259-2021-10-27-1669984704",
            issuer: "CMX",
            type: "ENCOUNTER_NUMBER"
        },
        exam_description: "CT ANGIO HEAD WITH AND WITHOUT CONTRAST, CT ANGIO NECK WITH CONTRAST",
        point_of_care: "MGH_MGH EMER",
        place_of_service: null,
        order_control: "RE",
        order_number: { number: "670845128", issuer: "EPC", type: "ORDER_NUMBER" },
        order_placer_number: {
            number: "670845128",
            issuer: "EPC",
            type: "ORDER_NUMBER"
        },
        order_filler_number: {
            number: "E15604814",
            issuer: "EPC",
            type: "ACCESSION_NUMBER"
        },
        ordering_provider_name: "SANCHEZ, JASON",
        ordering_provider_specialty: "",
        ordering_provider_number: {
            number: "1697825",
            issuer: "EPIC",
            type: "EPIC"
        },
        primary_clinical_identifier: {
            number: "E15604814",
            issuer: "EPC",
            type: "ACCESSION_NUMBER"
        },
        division: "MGHMC",
        exam_code: "CT.NE.AGHDNK@+",
        body_region: "Head and Neck",
        procedure_type: "Computed Tomographic Angiography",
        procedure_type_category: "CT",
        customer_automation_decision: null,
        date_of_service: "2021-10-27",
        datetime_of_service: "2021-10-27 00:50:00 EDT",
        exam_date: null,
        exam_datetime: null,
        result_status: "F",
        billing_location: "MGHMC",
        billing_area: null,
        billing_provider_specialty: "",
        billing_provider_name: "SCHAEFER, PAMELA",
        billing_provider_number: {
            number: "1000260",
            issuer: "EPIC",
            type: "EPIC"
        },
        billing_provider_assistant_name: "FREEZE, BENJAMIN",
        billing_provider_assistant_number: {
            number: "1560225",
            issuer: "EPIC",
            type: "EPIC"
        },
        scheduling_department: "MGH IMG CT ER MG WHT1",
        scheduling_department_code: "MGH_IMGCTERM",
        resource_name: "MGH CT1W1",
        resource_code: "CT1W1",
        relevant_clinical_info: null,
        placer_field_2: null,
        work_queue_name: "CT HEAD/NECK",
        billing_patient_identifier: null,
        attending_provider_specialty: null,
        attending_provider_name: null,
        attending_provider_number: null,
        referring_provider_specialty: null,
        referring_provider_name: "SANCHEZ, JASON",
        referring_provider_number: {
            number: "1697825",
            issuer: "EPIC",
            type: "EPIC"
        },
        rendering_provider_specialty: null,
        rendering_provider_name: "FREEZE, BENJAMIN",
        rendering_provider_number: {
            number: "1560225",
            issuer: "EPIC",
            type: "EPIC"
        },
        admission_datetime: null,
        discharge_datetime: null,
        performing_provider_specialty: null,
        performing_provider_name: null,
        performing_provider_number: null,
        service_provider_specialty: null,
        service_provider_name: null,
        service_provider_number: null,
        patient_primary_facility: null,
        service: null,
        transaction_id: null,
        sending_facility: "ICMPB RADMGH",
        claims_edit_enabled_indicator: null,
        tenant_insurance_plan_id: null,
        tenant_insurance_plan_text: null,
        tenant_insurance_payer_id: null,
        tenant_insurance_payer_name: null,
        tenant_insurance_payer_number: null,
        tenant_medicare_contractor: null,
        cmx_insurance_plan_text: "UNKNOWN PAYER (System Applied)",
        cmx_insurance_payer_id: "172",
        cmx_mapped_payer_number: null,
        cmx_payer_group_name_property_name: null,
        cmx_payer_category_property_name: null,
        claims_edit_indicator: true,
        cci_edit_indicator: true,
        medicare_jurisdiction: null,
        medicare_contractor: null,
        requires_medicaid_cci_edits_indicator: false,
        requires_cms_cci_edits_indicator: false,
        requires_ncd_edits_indicator: false,
        requires_lcd_edits_indicator: false,
        requires_commercial_edits_indicator: false,
        requires_mln_edits_indicator: false,
        requires_article_edits_indicator: false,
        requires_cms_manual_edits_indicator: false,
        requires_transmittal_manual_edits_indicator: false,
        claims_editor_payer_id: null,
        claims_editor_payer_name: null,
        claims_editor_issues: null,
        cci_editor_issues: null,
        custom_values: { routing: "CT1W1" },
        mappings: [],
        artifacts: [],
        notes: [],
        case_created_datetime: "2021-10-28 10:05:30 EDT",
        process_instance_created_datetime: "2021-10-28 10:05:30 EDT",
        exclusion_datetime: null,
        prediction_start_datetime: null,
        added_to_batch_datetime: "2021-10-28 10:06:33 EDT",
        response_from_batch_datetime: "2021-10-28 10:57:21 EDT",
        prediction_end_datetime: null,
        automation_decision_datetime: "2021-10-28 10:58:30 EDT",
        send_to_coder_datetime: null,
        received_from_coder_datetime: null,
        send_to_billing_datetime: "2021-10-28 10:59:41 EDT",
        process_instance_completed_datetime: "2021-10-28 10:59:47 EDT",
        case_completed_datetime: "2021-10-28 10:59:47 EDT",
        patient_age: null,
        post_manual_charges: true,
        prevent_billing_indicator: false,
        prevent_send_to_coder_indicator: false,
        automated_indicator: true,
        route_to_predict: true,
        route_to_billing: true,
        route_to_qa: false,
        route_to_coder: false,
        route_to_claims_editor: null,
        pre_prediction_process_reason: null,
        post_prediction_process_reason: "Automate:High Confidence",
        automate_decision_reason: "PREDICTION",
        termination_indicator: false,
        study_indicator: false,
        automation_eligible: true,
        can_automate: true,
        decoration: '{"Automate":["High Confidence"]}',
        hold_billing: false,
        hold_billing_reason: null,
        release_billing_reason: null,
        release_to_billing: false,
        release_to_coder: false,
        rules: '{"Automate":[{"decoration_category":"Automate","decoration_subcategory":"High Confidence","decoration_description":"Happy Path Prediction"}]}',
        process: null,
        phase: "LIVE",
        algorithm: "einstein",
        environment: "development",
        provenance: "CmxCaseBuilder",
        ml_function: "radiology-prediction",
        ml_version: "5.2.2",
        rule_evaluation_results: [],
        bpm_process_id: "1bfac956-37f8-11ec-85e5-d26b9f5b70df",
        case_s3_uri: "s3://process-data.development.app.codametrix.com/casedata/cases/21687.json",
        batch_s3_uri: "s3://process-data.development.app.codametrix.com/casedata/batches/B21687.json",
        prediction_s3_uri: "s3://process-data.development.app.codametrix.com/prediction/14ef61c5-d52f-428c-bc91-e1ed163914f5/batch/1/results_unmapped/results/21687.json",
        external_id: "OLD1-21687ST-20211028090529-032",
        billing_export_id: 12200,
        cac_export_id: null,
        billing_group_id: 11163,
        export_group_id: 2466,
        resubmit_date: null,
        submitter_process: null,
        submitted_primary_clinical_identifier: null,
        prediction_job_id: null,
        hl7_insurance_plan_id: null,
        hl7_insurance_plan_text: null,
        hl7_insurance_payer_id: null,
        hl7_insurance_payer_name: null,
        hl7_insurance_plan_type: null,
        scenario: null,
        case_type: null,
        specialty: null
    }
];
exports.testCaseSearchResult = testCaseSearchResult;
var launchParams = {
    launchPoint: null,
    patientIdentifier: null,
    providerID: null,
    providerName: null,
    serviceDate: null,
    transactionIds: null,
    uclIds: null,
    visitNumber: null
};
exports.launchParams = launchParams;
//# sourceMappingURL=search-result.js.map